const RecepiconIcon = ({ color, height, width, className }) => {
    return (
      <svg 
        width={height ? height: "18"} 
        height={width ? width : "18"} 
        viewBox="0 0 18 18" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        >
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M16 16H17C17.55 16 18 16.45 18 17C18 17.55 17.55 18 17 18H15C14.45 18 14 17.55 14 17V3H11V17C11 17.55 10.55 18 10 18H1C0.45 18 0 17.55 0 17C0 16.45 0.45 16 1 16H2V1C2 0.45 2.45 0 3 0H10C10.55 0 11 0.45 11 1H15C15.55 1 16 1.45 16 2V16ZM7 10H9V8H7V10Z" 
                fill={color ? color: "white"}/>
       </svg>
    );
  };
  
  export default RecepiconIcon;
  